import 'element-closest';
import { setDefaultOptions } from "date-fns";
import { enGB } from 'date-fns/locale';

setDefaultOptions({
  locale: enGB,
  weekStartsOn: 1
});

